export default "__VITE_ASSET__B_59C8Eq__"